/* The master pane's scroller and the list inside it.
 *
 * KANON `Programy v2 - D3 (0.8)`: `flex: 1, min-height: 0, overflow-y: auto, scrollbar-gutter:
 * stable`. The gutter is reserved rather than allowed to appear, because a scrollbar arriving with
 * the ninth row would narrow every row above it by the scrollbar's width — the canon's own note on
 * the clients list says the gutter must be stable "inaczej tory `fr` się rozjeżdżają".
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.scroller {
  /* The canon's helmet sizes its own scrollbar to EIGHT — `::-webkit-scrollbar{width:8px}` beside
   * the note that the gutter must be stable. Chromium's default is 15, and the seven px it takes
   * come straight off the row's flexible track: measured before this rule, the row was 444px
   * against the specimen's 451 and the name column 173 against 180. The bar is
   * `shared/ui/scrollbar`, which this element also carries. */
  --sb-size: 8px;
  --sb-radius: var(--radius-5px);

  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
}

/* The scroller is a named, focusable region: without a tab stop of its own, PageDown and End move
 * nothing at all until the trainer has tabbed into a row, because focus starts on `<body>` and the
 * body has no overflow. It is also where the arrow keys are heard, so they work whether focus is on
 * the region or on a row's link inside it. */
.scroller:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--outline-inset);
}

.list {
  display: flex;
  flex: none;
  flex-direction: column;
  margin: var(--space-0);
  padding: var(--space-0);
  list-style: none;
}
